<template>
    <div :style="messageColors" class="sc-message--system">
        {{ data.text }}
        <p v-if="data.meta" :style="{ color: messageColors.color }" class="sc-message--meta">
            {{ data.meta }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
// CHAT
.sc-message--system {
    padding: 8px 20px;
    border-radius: 6px;
    font-weight: 300;
    font-size: 12px;
    line-height: 1.2;
    white-space: pre-wrap;
    -webkit-font-smoothing: subpixel-antialiased;
    font-style: italic;
    opacity: 0.55;
}

.sc-message--meta {
    font-size: xx-small;
    margin-bottom: 0px;
    margin-top: 5px;
    opacity: 0.5;
    text-align: center;
}
</style>
